import fetchMock from 'fetch-mock';
import { url } from '../services/sendCodeWaGet';
import responseCreator from './helpers/responseCreator';
import withDelay from './helpers/withDelay';

fetchMock.get(`end:${process.env.REACT_APP_API_PATH}/${url}`, () => {
  return withDelay(new responseCreator().getResponse());
});
